import { render, staticRenderFns } from "./ModalFilesUpload.vue?vue&type=template&id=71e79a7a&scoped=true&"
import script from "./ModalFilesUpload.vue?vue&type=script&lang=js&"
export * from "./ModalFilesUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e79a7a",
  null
  
)

export default component.exports